"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4143],{

/***/ 44143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Reviews; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/ReviewCard/reviewCard.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: 26.5rem;\n    padding: 3.5rem 2rem 2rem 2rem;\n    margin-bottom: 3.5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2rem;\n    font-size: 1.5rem;\n    font-weight: 400;\n    line-height: 2.25rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 5rem;\n    max-height: 5rem;\n    height: 5rem;\n    width: 5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 2rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}





const ReviewCardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143wcmy0"
})("box-sizing:border-box;width:100%;max-width:35.5625rem;min-height:19.5rem;position:relative;display:flex;flex-direction:column;padding:3.5rem 2rem 2rem 2rem;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";border-radius:0.5rem;margin-bottom:4rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const QuoteText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e143wcmy1"
})(Typography/* ParagraphM */.Sl, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";letter-spacing:0.0125rem;margin:1rem 0 0 0;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const Person = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143wcmy2"
})("display:flex;flex-direction:row;align-items:center;margin-top:auto;");
const PersonImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143wcmy3"
})("position:relative;width:100%;height:100%;max-height:3rem;max-width:3rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";.person-image{object-fit:contain;}");
const PersonData = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e143wcmy4"
})("font-weight:400;margin:0 0 0 0.75rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const PersonName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e143wcmy5"
})(Typography/* ParagraphM */.Sl, ";display:block;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";");
const PersonCompanyPosition = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e143wcmy6"
})(Typography/* ParagraphXs */.CJ, ";font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4(), theme/* THEME.colors.black */.C.colors.black)), ";");

;// CONCATENATED MODULE: ./components/sections/ReviewCard/ReviewCard.tsx






const ReviewCard = (param)=>{
    let { name , position , company , photo , quote  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewCardWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "review-card__quote-icon testimonial__quote-icon"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteText, {
                children: prismic_reactjs.RichText.asText(quote)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Person, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonImage, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            ...(0,imageSerializer/* imageSerializer */.l)(photo),
                            className: "person-image"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonData, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonName, {
                                children: prismic_reactjs.RichText.asText(name)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonCompanyPosition, {
                                children: [
                                    prismic_reactjs.RichText.asText(position),
                                    ",",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonCompanyPosition, {
                                children: prismic_reactjs.RichText.asText(company)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/ReviewCard/index.ts

/* harmony default export */ var sections_ReviewCard = (ReviewCard);

;// CONCATENATED MODULE: ./components/sections/ClutchCard/ClutchCard.tsx


const ClutchCard = (param)=>{
    let { text  } = param;
    // TODO: fix types;
    (0,react.useEffect)(()=>{
        // @ts-ignore
        if ((window === null || window === void 0 ? void 0 : window.CLUTCHCO) && !window.CLUTCHCO.loaded) {
            // @ts-ignore
            window.CLUTCHCO.Init();
        }
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
        className: "clutch-card",
        href: "https://clutch.co/profile/qodeca#summary",
        rel: "noreferrer",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                className: "clutch-card__text",
                children: text
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "clutch-widget",
                "data-url": "https://widget.clutch.co",
                "data-widget-type": "2",
                "data-expandifr": "true",
                "data-height": "38",
                "data-clutchcompany-id": "568337",
                "data-primary-color": "#F94743"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/ClutchCard/index.ts

/* harmony default export */ var sections_ClutchCard = (ClutchCard);

;// CONCATENATED MODULE: ./components/sections/Reviews/reviews.styles.tsx

function reviews_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 7.5rem;\n    padding-top: 7.5rem;\n  "
    ]);
    reviews_styles_templateObject = function() {
        return data;
    };
    return data;
}
function reviews_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n  "
    ]);
    reviews_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function reviews_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    margin-bottom: 0;\n    margin-right: 3.5rem;\n  "
    ]);
    reviews_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function reviews_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 9rem;\n  "
    ]);
    reviews_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function reviews_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 0;\n    position: sticky;\n    padding-top: 4rem;\n  "
    ]);
    reviews_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    align-items: flex-start;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1g8rruo0"
})("position:relative;", mixins/* defaultContainerSize */.sX, ";margin:0;max-width:100%;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";padding-top:4rem;padding-bottom:4rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(reviews_styles_templateObject())), ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1g8rruo1"
})("width:100%;max-width:77.125rem;margin:0 auto;display:flex;flex-direction:column;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(reviews_styles_templateObject1())), ";");
const About = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1g8rruo2"
})("width:100%;margin-bottom:4rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(reviews_styles_templateObject2())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(reviews_styles_templateObject3())), ";");
const AboutSticky = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1g8rruo3"
})(mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(reviews_styles_templateObject4())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1g8rruo4"
})(Typography/* Header2 */.zV, ";margin:0 0 1.5rem 0;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const SpanTitle1 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1g8rruo5"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";");
const SpanTitle2 = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1g8rruo6"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1g8rruo7"
})(Typography/* ParagraphS */.fw, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";letter-spacing:0.0125rem;margin:0;");
const Cards = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1g8rruo8"
})("width:100%;display:flex;flex-direction:column;align-items:center;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");

;// CONCATENATED MODULE: ./components/sections/Reviews/Reviews.tsx





const Reviews = (param)=>{
    let { data , titleAs  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(About, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AboutSticky, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
                                as: titleAs,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpanTitle1, {
                                        children: data.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpanTitle2, {
                                        children: data.title2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                children: data.description
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Cards, {
                    children: [
                        data.reviews.map((review, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_ReviewCard, {
                                name: review.reviewer_name,
                                company: review.reviewer_company,
                                position: review.reviewer_position,
                                photo: review.reviewer_photo,
                                quote: review.review_text
                            }, index)),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_ClutchCard, {
                            text: data.clutch
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/Reviews/index.ts

/* harmony default export */ var sections_Reviews = (Reviews);


/***/ })

}]);